export function isConflictError(error: Error): boolean {
  return error.message.includes('409') || error.message.includes('modified');
}

export function isDuplicateError(error: Error): boolean {
  return error.message.includes('409') || error.message.includes('already exists');
}
